import { render, staticRenderFns } from "./attTransfer.vue?vue&type=template&id=2a9c0d86&scoped=true"
import script from "./attTransfer.vue?vue&type=script&lang=js"
export * from "./attTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9c0d86",
  null
  
)

export default component.exports